

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const BULKUPLOADSUBDEPARTMENTS= createAsyncThunk(
  "BULKUPLOADSUBDEPARTMENTS/bulkUploadSubDepartments",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const bulkUploadSubDepartmentsSlice = createSlice({
  name: "bulkUploadSubDepartmentsSlice",
  initialState: {
    bulkUploadSubDepartments: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfbulkUploadSubDepartments: (state) => {
        state.bulkUploadSubDepartments.loading = false
        state.bulkUploadSubDepartments.error = false
        state.bulkUploadSubDepartments.data = []
        state.bulkUploadSubDepartments.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(BULKUPLOADSUBDEPARTMENTS.fulfilled, (state, action) => {
      state.bulkUploadSubDepartments = {
        ...state.bulkUploadSubDepartments,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(BULKUPLOADSUBDEPARTMENTS.pending, (state, action) => {
      state.bulkUploadSubDepartments = {
        ...state.bulkUploadSubDepartments,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(BULKUPLOADSUBDEPARTMENTS.rejected, (state, action) => {
      state.bulkUploadSubDepartments = {
        ...state.bulkUploadSubDepartments,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const bulkUploadSubDepartmentsAction = {
    BULKUPLOADSUBDEPARTMENTS,
};

export { bulkUploadSubDepartmentsAction };
export default bulkUploadSubDepartmentsSlice.reducer;
export const {setInitialStateOfbulkUploadSubDepartments} = bulkUploadSubDepartmentsSlice.actions
